import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/snapchat.vue
var o = {
	name: "DtIconSnapchat",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--snapchat"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Snapchat",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [
		r("path", {
			d: "M19.8 0H4.2A4.2 4.2 0 0 0 0 4.2v15.6A4.2 4.2 0 0 0 4.2 24h15.6a4.2 4.2 0 0 0 4.2-4.2V4.2A4.2 4.2 0 0 0 19.8 0z",
			fill: "#fffc40"
		}, null, -1),
		r("path", {
			d: "M19.389 15.991c-2.667-1.29-3.092-3.284-3.11-3.432-.024-.179-.05-.32.148-.502.19-.176 1.036-.699 1.27-.863.388-.27.558-.541.433-.874-.088-.23-.303-.317-.528-.317a.985.985 0 0 0-.212.024c-.426.092-.84.306-1.079.363a.374.374 0 0 1-.088.012c-.128 0-.176-.056-.164-.21.03-.465.094-1.374.02-2.223-.1-1.168-.477-1.746-.924-2.258-.216-.248-1.22-1.314-3.155-1.314S9.062 5.463 8.847 5.708c-.448.512-.824 1.09-.924 2.258-.073.849-.007 1.757.02 2.223.009.146-.036.21-.164.21a.379.379 0 0 1-.088-.012c-.238-.057-.652-.27-1.078-.363A.985.985 0 0 0 6.401 10c-.226 0-.44.088-.528.317-.125.333.044.603.433.874.235.164 1.08.687 1.27.863.198.182.172.323.15.502-.02.15-.445 2.143-3.111 3.432-.157.076-.422.236.046.495.736.406 1.226.363 1.606.608.323.208.132.657.367.819.289.199 1.142-.015 2.244.35.924.304 1.486 1.164 3.124 1.164 1.639 0 2.216-.864 3.124-1.165 1.1-.364 1.955-.15 2.244-.35.235-.161.044-.61.367-.818.38-.245.87-.202 1.606-.608.468-.256.202-.416.046-.492z",
			fill: "#fff"
		}, null, -1),
		r("path", {
			d: "M20.55 15.84c-.12-.326-.348-.5-.608-.645a1.51 1.51 0 0 0-.132-.069c-.077-.04-.157-.079-.235-.12-.81-.429-1.441-.97-1.88-1.611a3.655 3.655 0 0 1-.322-.572c-.038-.107-.036-.168-.009-.223a.365.365 0 0 1 .103-.108l.38-.248c.173-.112.31-.201.4-.264.331-.233.564-.48.709-.755a1.505 1.505 0 0 0 .074-1.249c-.22-.579-.767-.939-1.43-.939a1.969 1.969 0 0 0-.524.07c.006-.396-.002-.814-.038-1.225-.125-1.447-.631-2.205-1.159-2.81a4.62 4.62 0 0 0-1.179-.948c-.801-.458-1.71-.69-2.7-.69s-1.895.232-2.697.69c-.443.25-.842.57-1.18.95-.529.605-1.035 1.364-1.16 2.81-.035.41-.044.831-.038 1.225a1.97 1.97 0 0 0-.524-.07c-.664 0-1.211.36-1.43.939a1.505 1.505 0 0 0 .072 1.25c.146.276.378.523.71.755.088.061.226.15.4.264l.364.238c.047.03.087.07.117.118.028.057.03.12-.013.234a3.622 3.622 0 0 1-.317.56c-.428.627-1.042 1.159-1.825 1.584-.415.22-.846.367-1.028.862-.137.373-.048.799.301 1.157.128.133.277.246.44.333.34.187.702.331 1.077.43a.71.71 0 0 1 .217.098c.127.111.11.279.279.524.085.127.193.237.318.324.356.246.755.261 1.179.277.382.015.815.032 1.31.195.205.068.418.199.665.352.593.364 1.404.863 2.762.863s2.175-.501 2.772-.867c.245-.15.457-.28.656-.346.495-.164.929-.18 1.31-.195.424-.016.824-.032 1.18-.277.148-.104.272-.239.362-.396.122-.207.119-.352.233-.453a.675.675 0 0 1 .204-.094c.38-.1.747-.245 1.091-.434a1.71 1.71 0 0 0 .462-.362l.005-.005c.327-.35.41-.763.275-1.128zm-1.208.648c-.736.407-1.225.363-1.606.608-.323.208-.132.657-.367.819-.288.2-1.142-.014-2.244.35-.909.3-1.489 1.164-3.124 1.164s-2.201-.862-3.125-1.167c-1.1-.363-1.955-.15-2.244-.35-.235-.161-.044-.61-.367-.818-.381-.245-.87-.202-1.606-.606-.469-.259-.203-.419-.047-.495 2.667-1.29 3.092-3.284 3.111-3.432.023-.179.049-.32-.149-.502-.19-.176-1.035-.699-1.27-.862-.388-.272-.559-.542-.433-.875.088-.23.303-.317.528-.317.071 0 .142.009.212.024.426.093.84.306 1.078.364a.379.379 0 0 0 .088.012c.128 0 .173-.065.164-.21-.027-.467-.093-1.375-.02-2.224.101-1.167.477-1.746.924-2.258.215-.246 1.224-1.312 3.153-1.312s2.941 1.062 3.156 1.307c.447.512.824 1.09.924 2.258.073.849.01 1.757-.02 2.223-.01.153.036.21.164.21a.38.38 0 0 0 .088-.012c.24-.057.653-.27 1.079-.363A.978.978 0 0 1 17.6 10c.227 0 .44.088.528.317.126.333-.044.603-.432.874-.235.164-1.08.687-1.27.863-.198.182-.172.323-.15.502.02.15.445 2.143 3.112 3.432.157.079.423.24-.046.5z",
			fill: "currentColor"
		}, null, -1)
	])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=snapchat.js.map